import styled from "styled-components";
import CompanyInfoForm from "./component";

export default styled(CompanyInfoForm)``;
